import { Action } from "redux"
import { action } from "typesafe-actions"

export enum ActionTypes {
    ADD_PHOTO_TO_POST = "ADD_PHOTO_TO_POST",
    CONTENT_UPDATED = "CONTENT_UPDATED",
    POST_SUBMIT_INIT = "POST_SUBMIT_INIT",
    POST_SUBMIT_SUCCESS = "POST_SUBMIT_SUCCESS",
}

export interface ActionPayload extends Action<ActionTypes> {
    payload: {
        content: string
        newURL: string
        mediaURL: string
    }
}

// form updating
export const updateContent = (content: string) => action(ActionTypes.CONTENT_UPDATED, { content })

export const addPhotoToPost = (mediaURL: string) => action(ActionTypes.ADD_PHOTO_TO_POST, { mediaURL })

// api calls :: init / success / error
export const submitPost = () => action(ActionTypes.POST_SUBMIT_INIT);
export const submitPostSuccess = (newURL: string) => action(ActionTypes.POST_SUBMIT_SUCCESS, { newURL })
